"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _datasets = require("../../utils/datasets");

var _datasets2 = _interopRequireDefault(_datasets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChecksController = function () {
  function ChecksController(ChecksService, FilterService, AuthService, NotificationService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ChecksController);
    this.checksService = ChecksService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(ChecksController, [{
    key: "$onInit",
    value: function $onInit() {
      this.visaCheckStatusOptions = {
        dataSource: [{ value: 1, text: "Pending Verification" }, { value: 2, text: "Approved" }, { value: 3, text: "Invalid" }, { value: 4, text: "Expired" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.checksService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        save: this.saveChanges.bind(this),
        height: "90vh",
        noRecords: {
          template: "No Checks."
        },
        columns: [{
          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "8rem",
          template: function template(dataItem) {
            return "<a class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\">" + dataItem.fullName + "</a>";
          }
        }, { field: "visaCheckStatus", title: "Check Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCheckStatus(dataItem.visaCheckStatus);
          } }, { field: "officialFirstName", title: "Given Name", filterable: false, sortable: false, width: "4rem" }, { field: "officialLastName", title: "Last Name", filterable: false, sortable: false, width: "4rem" }, { field: "passportNumber", title: "Passport Number", filterable: false, sortable: false, width: "4rem" }, { field: "passportCountry", title: "Passport Country", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCountry(dataItem.passportCountry);
          } },
        // { field: "creationDate", title: "Signup Date", filterable: false, sortable: false, width: "4rem", template: `#= creationDate ? kendo.toString(new Date(creationDate), 'dd/MM/yyyy'): '-' #` },
        { field: "dateOfBirth", title: "Date of Birth", filterable: false, sortable: false, width: "4rem", template: "#= dateOfBirth ? kendo.toString(new Date(dateOfBirth), 'dd/MM/yyyy'): '-' #" }, { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update Check Status" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "saveChanges",
    value: function saveChanges(e) {
      var check = e.model;

      if (check.visaCheckStatus == 2 && (!check.visaClass || !check.visaSubclass || !check.visaGrantDate || !check.visaExpiry)) {
        this.notificationService.error("Check missing fields and try again.");
        e.preventDefault();
      }
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.certificatesMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getCountry",
    value: function _getCountry(countryId) {
      var match = _datasets2.default.countriesIso.find(function (country) {
        return country.value === countryId || country.alpha2 === countryId;
      });

      if (!match) return "N/A";

      return match.label;
    }
  }, {
    key: "_getCheckStatus",
    value: function _getCheckStatus(status) {
      switch (status) {
        case _constants2.default.visaCheckStatus.PENDINGVERIFICATION:
          return "Pending";
        case _constants2.default.visaCheckStatus.APPROVED:
          return "Approved";
        case _constants2.default.visaCheckStatus.INVALID:
          return "Invalid";
        case _constants2.default.visaCheckStatus.EXPIRED:
          return "Expired";
      }
    }
  }]);
  return ChecksController;
}();

exports.default = ChecksController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/checks/checks.controller.js
 **/